import { render, staticRenderFns } from "./Step2.vue?vue&type=template&id=10c849a5&scoped=true"
import script from "./Step2.vue?vue&type=script&lang=ts"
export * from "./Step2.vue?vue&type=script&lang=ts"
import style0 from "./Step2.vue?vue&type=style&index=0&id=10c849a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c849a5",
  null
  
)

export default component.exports